<template>
    <div>
        <Header v-if="$store.getters.isEcosystem"></Header>
        <div v-if="$store.state.user.permissions.indexOf('tracker-template-manage') >= 0">
            <div v-if="$store.getters.isEnterprise" class="topbar topbar--full pt-4">
                <router-link to="/settings" class="link-back">All Settings</router-link>
                <h2 class="heading1 mb-0">Trackers</h2>
            </div>

            <div class="admin-page">
                <div class="tabs admin-page__tabs">
                    <b-nav tabs>
                        <li class="nav-item">
                            <a @click="currentTab = 'pipelines'" class="nav-link"
                               :class="{active: currentTab === 'pipelines'}">
                                Funnels
                            </a>
                        </li>
                        <li class="nav-item">
                            <a @click="currentTab = 'templates'" class="nav-link"
                               :class="{active: currentTab === 'templates'}">
                                Templates
                            </a>
                        </li>
                        <li class="nav-item">
                            <a @click="currentTab = 'submitter'" class="nav-link"
                               :class="{active: currentTab === 'submitter'}">
                                Details Fields
                            </a>
                        </li>
                        <li class="nav-item">
                            <a @click="currentTab = 'reviewer'" class="nav-link"
                               :class="{active: currentTab === 'reviewer'}">
                                Reviewer Fields
                            </a>
                        </li>
                        <li v-if="!$store.getters.isEcosystem" class="nav-item">
                            <a v-if="$store.state.accountType === 'premium'" @click="currentTab = 'questions'"
                               class="nav-link" :class="{active: currentTab === 'questions'}">
                                Startup Questions
                            </a>
                        </li>
                        <li class="nav-item">
                            <a @click="currentTab = 'diligence'" class="nav-link"
                               :class="{active: currentTab === 'diligence'}">
                                Startup Diligence
                            </a>
                        </li>
                    </b-nav>
                </div>

                <div class="admin-page__content main-inner">
                    <template>
                        <div v-show="currentTab === 'templates'">
                            <TemplatesList></TemplatesList>
                        </div>

                        <div v-show="currentTab === 'submitter'">
                            <FieldsList
                                type="tracker_submit">
                            </FieldsList>
                        </div>

                        <div v-show="currentTab === 'reviewer'">
                            <FieldsList
                                type="tracker_review">
                            </FieldsList>
                        </div>

                        <div v-if="$store.state.accountType === 'premium'" v-show="currentTab === 'questions'">
                            <FieldsList
                                type="tracker_question">
                            </FieldsList>
                        </div>

                        <div v-show="currentTab === 'diligence'">
                            <FieldsList
                                type="tracker_diligence">
                            </FieldsList>
                        </div>

                        <div v-show="currentTab === 'pipelines'">
                            <FieldsList
                                type="pipeline"
                                fieldType="pipeline"
                            >
                            </FieldsList>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FieldsList from "@/components/trackers/FieldsList";
import TemplatesList from "@/components/trackers/TemplatesList";
import Header from "@/views/ecosystem/settings/Header.vue";

export default {
    components: {
        Header,
        FieldsList,
        TemplatesList,
    },

    data() {
        return {
            currentTab: "pipelines",
        };
    },
}
</script>

<style scoped>

</style>
